import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import ButtonIcon from '../../../components/common/ButtonIcon';

export default function RelayHeaderButtons() {
  const { projectId } = useParams();
  const navigate = useNavigate();

  const { t } = useTranslation();

  return (
    <div className="d-flex justify-content-end flex-wrap gap-4">
      <ButtonIcon
        icon={['fa', 'arrow-left']}
        color="falcon-default"
        className="rounded-capsule text-nowrap"
        size="md"
        onClick={() => navigate(`/projects/${projectId}`)}
      >
        {t('Back to project')}
      </ButtonIcon>
      <ButtonIcon
        icon={['fa', 'arrow-left']}
        color="falcon-default"
        className="rounded-capsule text-nowrap"
        size="md"
        onClick={() => navigate(`/projects/${projectId}/switchboard`)}
      >
        {t('Switchboard')}
      </ButtonIcon>
    </div>
  );
}
